<template>
  <div>
    <div>
      <v-row>
        <v-col class="text-center">
          Hygienists/Assistants
          <v-expansion-panels v-model="hygienistExp" popout>
            <v-expansion-panel
              v-for="(item, i) in HygienistForDispute"
              :key="i"
            >
              <v-expansion-panel-header
                :disable-icon-rotate="pickedHygienist === item"
                :expand-icon="
                  pickedHygienist === item ? 'done' : 'mdi-menu-down'
                "
              >
                <div>
                  <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                  <span class="ml-2 text-caption grey--text">(ID: {{ item.id }})</span>
                  <br />
                  <span class="text-caption grey--text text--darken-1">{{ item.email || 'No email' }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list subheader two-line class="text-center">
                  <v-list-item-group>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>account_circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.id }}</v-list-item-title>
                        <v-list-item-subtitle>ID</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>face</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.firstName }}
                          {{ item.lastName }}</v-list-item-title
                        >
                        <v-list-item-subtitle>Name</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>explore</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.city }}
                          {{ item.province }}</v-list-item-title
                        >
                        <v-list-item-subtitle>Province</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    @click="
                      pickedHygienist = item;
                      hygienistExp = false;
                    "
                    color="purple darken-2"
                  >
                    Pick
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col class="d-flex justify-center">
          <v-btn
            color="primary"
            :disabled="!continueButton"
            @click="goNextStep"
          >
            Continue
            <v-icon>arrow_right_alt</v-icon>
          </v-btn>

          <v-btn small @click="$emit('back')" text>
            back
          </v-btn>
        </v-col>

        <v-col class="text-center">
          Locations
          <v-expansion-panels v-model="locationExp" popout>
            <v-expansion-panel v-for="(item, i) in LocationForDispute" :key="i">
              <v-expansion-panel-header
                :disable-icon-rotate="pickedLocation === item"
                :expand-icon="
                  pickedLocation === item ? 'done' : 'mdi-menu-down'
                "
              >
                <div>
                  <strong>{{ item.practiceName }}</strong>
                  <span class="ml-2 text-caption grey--text">(ID: {{ item.id }})</span>
                  <br />
                  <span class="text-caption grey--text text--darken-1">{{ item.email || 'No email' }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list two-line dense>
                  <v-list-item-group>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>account_circle</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.id }}</v-list-item-title>
                        <v-list-item-subtitle>ID</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>home</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          item.practiceName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>Name</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>location_on</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.address }} {{ item.city }}
                          {{ item.province }}</v-list-item-title
                        >
                        <v-list-item-subtitle>Adrress</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    @click="
                      pickedLocation = item;
                      locationExp = false;
                    "
                    color="purple darken-2"
                  >
                    Pick
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "selectLocationHygienist",
  data: () => ({
    hygienistExp: false,
    locationExp: false,
    pickedHygienist: null,
    pickedLocation: null,
    picked: null
  }),
  methods: {
    ...mapMutations(["modify"]),
    goNextStep() {
      this.modify({
        property: "LocationForDispute",
        value: [this.pickedLocation]
      });
      this.modify({
        property: "HygienistForDispute",
        value: [this.pickedHygienist]
      });
      this.$emit("next", {
        pickedHygienist: this.pickedHygienist ? this.pickedHygienist : [],
        pickedLocation: this.pickedLocation ? this.pickedLocation : []
      });
      this.pickedLocation = null;
      this.pickedHygienist = null;
    }
  },
  computed: {
    ...mapState(["LocationForDispute", "HygienistForDispute"]),
    continueButton() {
      if (
        this.HygienistForDispute.length >= 1 &&
        this.LocationForDispute.length >= 1
      ) {
        return this.pickedHygienist && this.pickedLocation;
      } else {
        return this.pickedHygienist || this.pickedLocation;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
